export default "__VITE_ASSET__CoriA8rp__"